import { render, staticRenderFns } from "./PromotionLink.vue?vue&type=template&id=ca072f70&scoped=true&"
import script from "./PromotionLink.vue?vue&type=script&lang=js&"
export * from "./PromotionLink.vue?vue&type=script&lang=js&"
import style0 from "./PromotionLink.vue?vue&type=style&index=0&id=ca072f70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca072f70",
  null
  
)

export default component.exports